export interface PaletteOperatorPrefs {
  showRecent: boolean;
  showPages: boolean;
  showConsole: boolean;
  showWebsites: boolean;
  showServers: boolean;
  showSiteClearTip: boolean;
  showSiteUseTip: boolean;
  showBrowseHint: boolean;
  showResourceHints: boolean;
}

const PREFS_KEY = 'global-palette.prefs';

export const DEFAULT_PALETTE_PREFS: PaletteOperatorPrefs = {
  showRecent: true,
  showPages: true,
  showConsole: true,
  showWebsites: true,
  showServers: true,
  showSiteClearTip: true,
  showSiteUseTip: true,
  showBrowseHint: true,
  showResourceHints: true,
};

export function loadPalettePrefs(): PaletteOperatorPrefs {
  try {
    const raw = localStorage.getItem(PREFS_KEY);
    if (!raw) {
      return { ...DEFAULT_PALETTE_PREFS };
    }
    const parsed = JSON.parse(raw);
    return {
      showRecent: parsed.showRecent !== false,
      showPages: parsed.showPages !== false,
      showConsole: parsed.showConsole !== false,
      showWebsites: parsed.showWebsites !== false,
      showServers: parsed.showServers !== false,
      showSiteClearTip: parsed.showSiteClearTip !== false,
      showSiteUseTip: parsed.showSiteUseTip !== false,
      showBrowseHint: parsed.showBrowseHint !== false,
      showResourceHints: parsed.showResourceHints !== false,
    };
  } catch {
    return { ...DEFAULT_PALETTE_PREFS };
  }
}

export function savePalettePrefs(prefs: PaletteOperatorPrefs): void {
  try {
    localStorage.setItem(PREFS_KEY, JSON.stringify(prefs));
  } catch {
    // ignore quota / private mode
  }
}
